'use client'

interface ProfileGateProps {
  children: React.ReactNode
}

/**
 * Booking no longer blocks on profile completeness — patients book freely.
 * Profile completion (incl. NIR for France billing) is enforced later, at the
 * video-consultation entry (the waiting-room gate). Kept as a pass-through so the
 * booking-step composition (AuthenticationGate → ProfileGate) is unchanged; the
 * surrounding AuthenticationGate still requires login.
 */
export function ProfileGate({ children }: ProfileGateProps) {
  return <>{children}</>
}
